import React, { useRef, useState } from 'react'
import { Body, Box, H2 } from '../layout'
import { useObserver } from '../../hooks'
import { Pill } from '../widgets'
import './NotAnotherSurvey.css'

export const NotAnotherSurvey = () => {
  const withShivoo = useRef()
  const withoutShivoo = useRef()

  const [withShivooAnimate, setWithShivooAnimate] = useState(false)
  const [withoutShivooAnimate, setWithoutShivooAnimate] = useState(false)

  useObserver(withShivoo, () => setWithShivooAnimate(true), 0.7, 0.7)
  useObserver(withoutShivoo, () => setWithoutShivooAnimate(true), 0.7, 0.7)

  return (
    <Box className="not-another-survey" gap={40} justifyContent="center" alignItems="center" column fullWidth>
      <H2>Not another team survey</H2>

      <Box className="side-by-side" gap={40} fullWidth>
        <Box className="section" column gap={16} fullWidth>
          <Box>
            <Pill text={<>with <Body bold>Shivoo</Body></>} small/>
          </Box>
          <Box
            className="pill-container"
            background="linear-gradient(180deg, #101010 27.87%, #00F 220.62%)"
            ref={withShivoo}
          >
            <Box container fullWidth>
              <Pill
                text="Team answers together"
                icon="People"
                iconColor="#929292"
                start={{top: 150, left: true, rotate: 6}}
                transform="rotate(-6deg) translateY(-150%)"
                transitionDelay="0.05s"
                active={withShivooAnimate}
              />
              <Pill
                text="Real-time results"
                icon="Clock"
                color="black"
                background="white"
                iconColor="black"
                start={{top: 175, right: true, rotate: -9}}
                transform="rotate(3deg) translateY(-90%)"
                transitionDelay="0.10s"
                active={withShivooAnimate}
              />
              <Pill
                text="Ongoing development"
                icon="Graph"
                color="white"
                background="black"
                iconColor="#929292"
                start={{top: 200, left: true, rotate: -6}}
                transform="rotate(12deg) translateY(-20%)"
                transitionDelay="0.15s"
                active={withShivooAnimate}
              />
              <Pill
                text="Team-level analysis"
                icon="ArrowZigZag"
                iconColor="#929292"
                start={{top: 225, right: true, rotate: -9}}
                transform="translateY(50%)"
                transitionDelay="0.20s"
                active={withShivooAnimate}
              />
              <Pill
                text="Active debate"
                icon="PersonTalking"
                color="black"
                background="white"
                iconColor="black"
                start={{top: 250, left: true, rotate: 7}}
                transform="translateY(110%) translateX(25px)"
                transitionDelay="0.25s"
                active={withShivooAnimate}
              />
            </Box>
          </Box>
        </Box>

        <Box className="section" column gap={16} fullWidth>
          <Box>
            <Pill text={<>without <Body bold>Shivoo</Body></>} color="white" background="#212121" small/>
          </Box>
          <Box
            className="pill-container"
            background="linear-gradient(180deg, #1F1F1F 27.87%, #000 220.62%)"
            ref={withoutShivoo}
          >
            <Box container fullWidth>
              <Pill
                text="Individual survey"
                icon="Person"
                color="#727272"
                background="#3B3B3B"
                iconColor="#727272"
                start={{top: 150, left: true, rotate: 3}}
                transform="rotate(-3deg) translateY(-150%)"
                transitionDelay="0.05s"
                active={withoutShivooAnimate}
              />
              <Pill
                text="Delayed reports"
                icon="BadFile"
                color="#929292"
                background="#585858"
                iconColor="#929292"
                start={{top: 175, right: true, rotate: 9}}
                transform="rotate(-18deg) translateY(-100%)"
                transitionDelay="0.10s"
                active={withoutShivooAnimate}
              />
              <Pill
                text="Static insight"
                icon="LightBulb"
                color="#727272"
                background="#3B3B3B"
                iconColor="#727272"
                start={{top: 200, left: true, rotate: 6}}
                transform="translateY(-50%)"
                transitionDelay="0.15s"
                active={withoutShivooAnimate}
              />
              <Pill
                text="Individual profiles"
                icon="ID"
                color="#929292"
                background="#585858"
                iconColor="#929292"
                start={{top: 225, right: true, rotate: -6}}
                transform="rotate(-3deg) translateY(-25%) translateX(-20px)"
                transitionDelay="0.20s"
                active={withoutShivooAnimate}
              />
              <Pill
                text="Passive reflection"
                icon="BadBrowser"
                color="#727272"
                background="#3B3B3B"
                iconColor="#727272"
                start={{top: 250, left: true, rotate: -9}}
                transform="rotate(9deg) translateY(80%)"
                transitionDelay="0.25s"
                active={withoutShivooAnimate}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}